/**
 * CommUtil.js
 * 공통 유틸리티 함수 모음
 */


/**
 * Save each field under the original key name.
 * @example
 * setKeyLocalStorage({ pjtSeq: '123' });
 */
export const setObjLocalStorage = (obj) => {
    Object.keys(obj).forEach(key => {
        const value = obj[key];
        localStorage.setItem(key, value === null || value === undefined ? "" : String(value));
    });
};

/**
 * Load each field by its original key name.
 * @example
 * const data = getKeyLocalStorage({ pjtSeq: '' });
 */
export const getObjLocalStorage = (fallback) => {
    const result = { ...fallback };

    Object.keys(fallback).forEach(key => {
        const storageValue = localStorage.getItem(key);
        if (storageValue !== null && storageValue !== '') {
            result[key] = storageValue;
        }
    });

    return result;
};
